import { useState, useCallback } from 'react';
import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { TopBar } from '../TopBar';
import { Navigation } from '../Navigation';
import { MobileNavDrawer } from '../MobileNavDrawer';
import { Footer } from '../Footer';
import { useIsMobileView } from '../../hooks/useWindowSize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PageLayout = ({
  children
}) => {
  const isMobileView = useIsMobileView();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const openMobileNav = useCallback(() => setIsMobileNavOpen(true), []);
  const closeMobileNav = useCallback(() => setIsMobileNavOpen(false), []);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "INDEX_LOAD",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      minBlockSize: "100vh",
      maxBlockSize: isMobileView ? undefined : '100vh',
      children: [/*#__PURE__*/_jsx(TopBar, {
        onHamburgerClick: openMobileNav
      }), /*#__PURE__*/_jsxs(Flex, {
        flexGrow: 1,
        justifyContent: "start",
        children: [/*#__PURE__*/_jsx(Navigation, {}), /*#__PURE__*/_jsxs(Flex, {
          flexGrow: 1,
          flexDirection: "column",
          alignItems: "stretch",
          children: [/*#__PURE__*/_jsx(Flex, {
            flexGrow: 1,
            overflowY: "auto",
            backgroundColor: "fill-surface-recessed",
            children: children
          }), /*#__PURE__*/_jsx(Footer, {})]
        })]
      })]
    }), /*#__PURE__*/_jsx(MobileNavDrawer, {
      isOpen: isMobileNavOpen,
      onClose: closeMobileNav
    })]
  });
};